import Swal from 'sweetalert2';
import formatUtil from './formatUtil';

exports.showErrorMessage = function (errorMessage, callback) {
    Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
    }).then(function() {
        if (callback)
            callback();
    });
}

exports.showErrorMessageHtml = function (errorMessage, callback) {
    Swal.fire({
        icon: 'error',
        title: 'Error',
        html: errorMessage,
    }).then(function() {
        if (callback)
            callback();
    });
}


exports.showSuccessMessage = function (successMessage, callback) {
    Swal.fire({
        icon: 'success',
        title: 'Success',
        text: successMessage,
    }).then(function() {
        if (callback)
            callback();
    });
}

exports.showAlertMessageHtml = function (alertMessage, callback) {
  Swal.fire({
    html: alertMessage,
  }).then(function() {
    if (callback)
      callback();
  });
}

exports.showUser = function (userMap, callback) {
  let workPhone = formatUtil.formatPhone(userMap.workPhone, false);
  let cellPhone = formatUtil.formatPhone(userMap.cellPhone, true);
  let detail = '<table class="userDetailPopup" style="width: 100%">' +
    '<tr><td>Name:</td><td>' + userMap.fullName + '</td></tr>' +
    '<tr><td>Title:</td><td>' + userMap.title + '</td></tr>' +
    '<tr><td>Email:</td><td>' + userMap.username + '</td></tr>' +
    '<tr><td>Work Phone:</td><td>' + workPhone + '</td></tr>' +
    '<tr><td>Cell Phone:</td><td>' + cellPhone + '</td></tr>' +
    '<tr><td>Address:</td><td>' + userMap.address + '</td></tr>' +
    '</table>';
  Swal.fire({
    title: 'User Detail',
    width: '600px',
    html: detail,
  }).then(function() {
    if (callback)
      callback();
  });
}

exports.confirm = function (confirmQuestion, callbackIfConfirmed) {
  Swal.fire({
    title: 'Are you sure?',
    text: confirmQuestion,
    showCancelButton: true,
    //confirmButtonColor: '#3085d6',
    //cancelButtonColor: '#d33',
    //confirmButtonText: 'Yes, delete it!'
  }).then((result) => {
    if (result.isConfirmed) {
        callbackIfConfirmed();
    }
  })
}



// WEBPACK FOOTER //
// ./client/app/_helpers/dialogUtil.js